import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';
import { AulaLezioneGruppoStudioDTO, ListStudentiDTO, MioGruppoStudioDTO, SelectDTO } from 'src/app/model/newModel';
import { SharedService } from 'src/app/shared/shared.service';

import { DashboardAdministratorService } from './dashboard-administrator.service';

@Component({
  selector: 'app-dashboard-administrator',
  templateUrl: './dashboard-administrator.component.html',
  styleUrls: ['./dashboard-administrator.component.css'],
})
export class DashboardAdministratorComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  instructors: SelectDTO[];
  mieiGruppiStudio: MioGruppoStudioDTO[];
  mieiCalendariGruppoStudio: AulaLezioneGruppoStudioDTO[];
  now: Date;
  idInstructor: number;
  startSearch = false;
  listStudenti: ListStudentiDTO;
  showStudenti: boolean;
  agendeDaVerificare: number;

  goToStudenteDetail(idStudente: number, idSessioneOla: number) {
    this.router.navigate(['/a-studente/dettaglio'], {
      queryParams: { idStudente: idStudente, idSessioneOla: idSessioneOla },
    });
  }

  ngOnInit(): void {
    this.now = new Date();
    super.ngOnInit();
    this.startSearch = false;
    this.loadInstructors();
    this.searchStudenti();
    this.loadAgendeDaVerificare();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  loadAgendeDaVerificare() {
    this.spinner.show();
    this.sharedService.getTotaleAgendeDaVerificare().subscribe(
      (result: number) => {
        this.agendeDaVerificare = result;
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore getTotaleAgendeDaVerificare');
        this.spinner.hide();
      }
    );
  }

  goToAgendeDaVerificare() {
    this.router.navigate(['a-agenda/verificare']);
  }

  loadMieiGruppiStudio(idInstructor: number) {
    this.spinner.show();
    this.sharedService.getMieiGruppiStudio(idInstructor).subscribe(
      (result) => {
        this.mieiGruppiStudio = result.gruppiStudio;
        this.mieiCalendariGruppoStudio = result.auleLezioneGruppoStudio;
        this.startSearch = true;
        this.spinner.hide();
      },
      (error) => {
        console.log('Errore getMieiGruppiStudio');
        this.spinner.hide();
      }
    );
  }

  loadInstructors() {
    this.sharedService.selectInstructorsAttivi().subscribe(
      (result) => {
        this.instructors = _.orderBy(result.list, 'viewValue', 'asc');
      },
      (error) => {
        console.log('Errore selectInstructorsAttivi');
      }
    );
  }

  constructor(
    public router: Router,
    private dashboardAdministratorService: DashboardAdministratorService,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService
  ) {
    super();
  }

  searchStudenti() {
    // SE E' NEI PRENOTATI E ANCORA NON SUPERATO
    this.spinner.show();
    this.dashboardAdministratorService
      .studentiProvaFinaleNonSuperataNVolte()
      .subscribe(
        (result) => {
          this.listStudenti = result;
          if (
            !!this.listStudenti.studenti &&
            this.listStudenti.studenti.length > 0
          ) {
            this.showStudenti = true;
          } else {
            this.showStudenti = false;
          }
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore searchStudentiPrenotatiPiuVolte');
        }
      );
  }
}
